import { Breadcrumb, Card, Col, EventHandler, Label, PrimaryButton, ReactSelectBox, Row, Search, SofturaTable, Tooltip } from "client/CommonComponents";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import CreateNewOrderIcon from '../../../../assets/images/New Order.svg'
import './Home.scss';
import { breadcrumlist } from "./HomeHelper";
import permissions, { ACCESS_DENIED, isAuthorized } from "client/utils/Permissions";
import { returGridHeaderClassName } from "utils";
import LoadingWrapper from "../../../../CommonComponents/LoadingWrapper"

const Home = (props: any) => {

  const {
    gridData,
    searchValue,
    dateRange,
    onSearchOrder,
    onDateRangeChange,
    bulkOrderColumn,
    setFilters,
    serverTotal,
    fetchAction,
    pagesCount,
    handleFilterClear,
    handleClick,
    activeMenu,
    showGrid,
    isBulkOrderGridLoading,
    isBulkOrderGridCountsLoading,
    isDropDownsLoading,
    searchByOptions,
    globalSearchBy,
    onGlobalSearchByChange,
    alreadyHasGridFilterValues
  } = props;
  
  return (
    <div className='mt-md-1'>
      <div className='breadCrumbBlock breadcrumb-toolbar'>
        <div className='create-asset-btnBlock'>
          <button
            disabled={!(isAuthorized(permissions.CreateUpdateBulkOrder) || isAuthorized(permissions.ViewBulkOrder))}
            className='create-new-order-btn me-2'
            title={(isAuthorized(permissions.CreateUpdateBulkOrder) || isAuthorized(permissions.ViewBulkOrder)) ? 'Create Bulk Order' : ACCESS_DENIED}
            onClick={props.CreateBulkOrderClick} data-attribute="Home_Default_Button">
            <img src={CreateNewOrderIcon} alt='btn-icon' />
            <span>Create Bulk Order</span>
          </button>

                </div>
                <div className='breadcrumbList'>
                    <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="Home_Default_Breadcrumb" />
                </div>
            </div>
            <div className={'CustomerMyOrder '}>
                <div className='create-new-bulk-order-container create-new-order-container'>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Card data-attribute="Home_Default_Card">
                                <div className='create-new-order-block mb-md-3'>
                                    {
                                        props?.orderList.map((item: any, index: number) => {
                                            const getActiveMenu = () => {
                                                if (activeMenu === item?.displayText) {
                                                    return ("active");
                                                } else {
                                                    return ('');
                                                }
                                            }
                                            const unSubmittedVal = () => {
                                                if ('Unsubmitted' === item?.displayText) {
                                                    return ("active");
                                                } else {
                                                    return ('');
                                                }
                                            }
                                            return (
                                                <EventHandler onEvent={() => handleClick(item?.displayText)}>
                                                    <div key={index} className={props?.cartNav == '' ? (`create-new-order ${item.icontype} ${getActiveMenu()}`) : (`create-new-order ${'draft'} ${unSubmittedVal()}`)}  data-attribute={`Home_${(item?.displayText || item?.text || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Item`}>
                                                        <div className='pull-left'>
                                                            <p className='order-type'>{item.text}</p>
                                                            <LoadingWrapper isLoading={isBulkOrderGridCountsLoading} data-attribute="Home_Default_LoadingWrapper">
                                                                <EventHandler onEvent={(e: any) => e.preventDefault()} data-attribute={`Home_${(item?.displayText || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Link_EventHandler`}>
                                                                    <a className='order-link' href='/'>{item?.link}</a>
                                                                </EventHandler>
                                                            </LoadingWrapper>
                                                            <span className='subText'>{item?.subText ? `(${item?.subText})` : ''}</span>
                                                        </div>
                                                        <div className='pull-right'>
                                                            <div className='order-icon'>
                                                                {
                                                                    activeMenu === item.displayText ?
                                                                        <img src={item?.activeIcon} alt='order-icons' /> :
                                                                        <img src={item?.icon} alt='order-icons' />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </EventHandler>
                                            )
                                        }
                                        )
                                    }
                                </div>
                                <div className='grid-block pt-2'>
                                    <div className='mb-1 top-section'>
                                        <p className='mt-1'>BULK ORDERS</p>
                                        <div className='clearfix mt-2 mb-3'>
                                            <div className='pull-left searchblock global-search'>
                                                <Label className="mb-0" data-attribute="Home_Default_Label">Search By</Label>
                                                <div className='search-dropdown-block'>
                                                    <ReactSelectBox
                                                        name='globalSearch'
                                                        options={searchByOptions}
                                                        value={globalSearchBy}
                                                        onChange={onGlobalSearchByChange}
                                                        className='global-search-drop-down'
                                                     data-attribute="Home_globalSearch_SearchSelectBox" />
                                                    <Search
                                                        placeholder={`Search By ${globalSearchBy?.label}`}
                                                        className='searchTextbox'
                                                        onSearch={(e?: any) => onSearchOrder(e, true)}
                                                        onBlur={(e?: any) => onSearchOrder(e, false)}
                                                        onChange={(e?: any) => onSearchOrder(e, false)}
                                                        value={searchValue}
                                                     data-attribute="Home_Default_Searchbox" />
                                                </div>
                                            </div>
                                            <div className='pull-right datepickerControl mb-2 mb-sm-0 mt-sm-0 mt-2'>
                                                <DateRangePicker
                                                    placement='bottomEnd'
                                                    format="MM-dd-yyyy"
                                                    character=' - '
                                                    onChange={onDateRangeChange}
                                                    placeholder='MM-DD-YYYY - MM-DD-YYYY'
                                                    preventOverflow={true} value={dateRange}
                                                    defaultCalendarValue={[new Date(moment().startOf('month').toDate()), new Date(moment().add(1, 'months').startOf('month').toDate())]}
                                                 data-attribute="Home_Default_DateRangePicker" />
                                                <PrimaryButton text='Clear Filters' disabled={alreadyHasGridFilterValues()} onClick={handleFilterClear} className='filter-btn ms-2'  data-attribute="Home_Default_Button_2" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${gridData?.length != 0 ? "softura-table" : "softura-table paginationNav"} ${returGridHeaderClassName(activeMenu)}`}>
                                        {showGrid && <SofturaTable
                                            key={props?.gridKey}
                                            data={gridData ?? []}
                                            columns={bulkOrderColumn}
                                            sort={true}
                                            defaultPageSize={10}
                                            getFilterValue={setFilters}
                                            pageSizes={[10, 20, 50]}
                                            globalSearch={false}
                                            filter={true}
                                            serverTotal={serverTotal}
                                            fetchAction={fetchAction}
                                            isServerSide={true}
                                            pagesCount={pagesCount}
                                            defaultPaginationPosition='Both'
                                            fixedHeader={true}
                                            loading={isBulkOrderGridLoading || isDropDownsLoading}
                                         data-attribute="Home_Default_Grid" />}
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default Home;